import React from 'react'; 
import PropTypes from 'prop-types';

const OffRampMessageSubmitRequest = ({offRampMessage}) => {
    return (
        <div>
         <div dangerouslySetInnerHTML={{ __html: offRampMessage }} />           
        </div>
    );
};

OffRampMessageSubmitRequest.propTypes = {
    offRampMessage: PropTypes.string
};
export default OffRampMessageSubmitRequest;